module.exports = __webpack_public_path__ + "img/0.267a8fb8.png";